export const regexEmail =
/^[a-z0-9" "!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const regexNombre = /^[a-zA-ZáéíóúAÉÍÓÚÑñ ]+(\s+[a-zA-ZáéíóúAÉÍÓÚÑñ]+)*$/;
export const regexNumero = /^([0-9])*$/;
export const regexNumeroLetras = /^[A-Za-z0-9 _]*[A-Za-z0-9 _]*$/;
export const regexUserLogin = /^[0-9a-zA-Z]+$/;



